/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { Button, Select, Row, Col } from "antd";
import { Modal } from "antd";
import { CloseOutlined, FormOutlined } from "@ant-design/icons";

const { Option } = Select;
const FilterTemplates = ({
  visible,

  applications,
  selectedApplications,
  setSelectedApplications,

  types,
  selectedTypes,
  setSelectedTypes,

  roles,
  selectedRoles,
  setSelectedRoles,

  handleApply,
  handleCancel,
  ResetFields,
}) => {
  console.log(visible);
  console.log(applications);

  // eslint-disable-next-line no-unused-vars

  const handleApplicationsSelect = (value) => {
    console.log(value);
    setSelectedApplications(value);
  };
  const handleRolesSelect = (value) => {
    console.log(value);
    setSelectedRoles(value);
  };
  const handleTypesSelect = (value) => {
    console.log(value);
    setSelectedTypes(value);
  };

  return (
    <Modal
      title={<p className="modal-heading">FILTER EMAIL TEMPLATES</p>}
      onOk={handleApply}
      open={visible}
      footer={null}
      onCancel={handleCancel}
    >
      <Row
        gutter={[16, 16]}
        style={{
          padding: "1rem",
          marginTop: "1.5rem",
        }}
      >
        <Col span={6}>
          <p className="my-form-lables" style={{ marginTop: "5px" }}>
            APPLICATIONS{" "}
          </p>
        </Col>
        <Col span={18}>
          <Select
            showSearch
            placeholder="Select Applications"
            className="my-form-input"
            style={{
              width: "100%",
              borderRadius: "0.7rem",
              borderColor: "#818589",
            }}
            onChange={handleApplicationsSelect}
            value={selectedApplications}
            mode="multiple"
          >
            {applications?.map((app) => (
              <Option key={app.key_name} value={app.key_name}>
                {`${app.name}`}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Row
        gutter={[16, 16]}
        style={{
          padding: "1rem",
        }}
      >
        <Col span={6}>
          <p className="my-form-lables" style={{ marginTop: "5px" }}>
            USER ROLES{" "}
          </p>
        </Col>
        <Col span={18}>
          <Select
            showSearch
            placeholder="Select user roles"
            className="my-form-input"
            style={{
              width: "100%",
              borderRadius: "0.7rem",
              borderColor: "#818589",
            }}
            onChange={handleRolesSelect}
            value={selectedRoles}
            mode="multiple"
          >
            {roles?.map((role, index) => (
              <Option key={index} value={role}>
                {role}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Row
        gutter={[16, 16]}
        style={{
          padding: "1rem",
        }}
      >
        <Col span={6}>
          <p className="my-form-lables" style={{ marginTop: "5px" }}>
            TYPE{" "}
          </p>
        </Col>
        <Col span={18}>
          <Select
            showSearch
            placeholder="Select type"
            className="my-form-input"
            style={{
              width: "100%",
              borderRadius: "0.7rem",
              borderColor: "#818589",
            }}
            onChange={handleTypesSelect}
            value={selectedTypes}
            mode="multiple"
          >
            {types?.map((type, index) => (
              <Option key={index} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>

      <Row
        style={{
          justifyContent: "flex-end",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Button key="back" onClick={handleCancel}>
          <CloseOutlined />
          Cancel
        </Button>
        <Button
          type="primary"
          onClick={ResetFields}
          style={{ marginLeft: "1rem" }}
        >
          Reset
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            background: "#f58029",
            fontWeight: "600",
            marginLeft: "1rem",
          }}
          onClick={handleApply}
          className="save-update-btn"
        >
          Apply
          <FormOutlined />
        </Button>
      </Row>
    </Modal>
  );
};

export default FilterTemplates;
